import styled from '@emotion/styled';
import { useState } from 'react';

import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

import { ReactComponent as Help } from '../ui/icons/help.svg';
import { ReactComponent as Clock } from '../ui/icons/Horloge.svg';

import { Project } from '@gameonly/core';
import { useTranslation } from 'react-i18next';
import CompletionBar from '../project/CompletionBar';
import CompletionDetails from '../project/CompletionDetails';

const CompletionContainer = styled.div`
  width: 200px;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  cursor: pointer;
`;

const Right = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  justify-content: space-between;
`;

const TopRight = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

const Completion = ({
  project,
  onClick,
}: {
  project: Project;
  onClick: () => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLOrSVGElement | null>(null);
  const { t } = useTranslation(['project']);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const hasRequiredFields = project.model.hasRequiredFields;
  const completionRate = project.completionRate;

  return (
    <CompletionContainer onClick={handleClick}>
      <CompletionDetails
        placement="bottom-end"
        uncompleted={project.uncompleted}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
      />
      {!hasRequiredFields ? (
        <Help />
      ) : completionRate === 100 ? (
        <CheckCircleOutlineOutlinedIcon color="success" fontSize="large" />
      ) : (
        <Clock style={{ height: '36px', width: '36px' }} />
      )}
      <Right>
        <TopRight>
          <p className="h5b">{project.completionRate}%</p>
          <p className="hxr">
            {project.model.singularName.toLocaleLowerCase()} completion
          </p>
        </TopRight>
        <CompletionBar completionRate={completionRate} width="100%" />
      </Right>
    </CompletionContainer>
  );
};

export default Completion;
